import React from "react";
import { Breadcrumb } from "../../../components/Breadcrumb";

export const Owner = () => {
    document.title = "Sənədlərdə cavabdeh";

    const menu = [
        { name: "Ana səhifə", value: "/" },
        { name: "Ümumi anlayışlar", value: "/common" },
        { name: "Sənədlərdə cavabdeh", value: "/common/owner", current: true },
    ];

    return (
        <div>
            <Breadcrumb menu={menu} />
            <div className="container">
                <article>
                    <h2 className="my-4">Sənədlərdə cavabdeh</h2>
                    <p>Sənədlərin cavabdehi, sənədləri yaradan istifadəçini bildirir. Cavabdehə görə axtarışlarda hesabatlar əldə etmək olar.</p>
                    <img src="/images/common/owner.gif" alt="Sənədlərdə cavabdeh" />
                </article>
            </div>
        </div>
    );
};
